import React from "react";

export default function LoadingSpinner({ isLoading = false }) {
  return (
    isLoading && (
      <div id="global-loader">
        <div className="whirly-loader"></div>
      </div>
    )
  );
}
